import { supabase } from '@/lib/supabase'

export async function getAccountIdForUser(userId: string): Promise<string | null> {
  const uid = String(userId || '').trim()
  if (!uid) return null

  // Prioriza conta em que o usuario e owner
  try {
    const { data, error } = await supabase
      .from('account_users')
      .select('account_id')
      .eq('user_id', uid)
      .eq('role', 'owner')
      .limit(1)
    if (error) throw error
    const id = String((data || [])[0]?.account_id || '').trim()
    if (id) return id
  } catch {}

  // Fallback: primeira conta encontrada
  const { data, error } = await supabase.from('account_users').select('account_id').eq('user_id', uid).limit(1)
  if (error) throw error
  const id = String((data || [])[0]?.account_id || '').trim()
  return id || null
}

